export const UK = {
    name: "United Kingdom",
    image: "/UK.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose UK for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose the UK for its world-renowned education system, prestigious universities, and rich cultural heritage. The country offers globally recognized qualifications and excellent career prospects.",
            "The UK's long-standing tradition of academic excellence, diverse student community, and strong industry connections make it an ideal destination for international students seeking quality education and professional development."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "London, Edinburgh, and Manchester rank among the top student cities globally, offering world-class universities and vibrant cultural scenes."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "The UK offers the Graduate Route visa allowing international students to work for up to 2 years (undergraduate/master's) or 3 years (PhD) after graduation."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "The UK has 4 universities in the top 10 of the QS World University Rankings, with Oxford, Cambridge, Imperial College London, and UCL leading globally."
        },
        {
            icon: "fas fa-users",
            title: "Cultural diversity",
            description: "The UK's multicultural society and diverse student population provide a rich, inclusive educational experience with students from over 200 countries."
        }
    ],
    keyFacts: [
        { factNumber: "160+", factLabel: "Universities and colleges" },
        { factNumber: "6,00,000", factLabel: "International Students in UK in 2024" },
        { factNumber: "20 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "3 Years", factLabel: "Post-study work permit (PhD)" }
    ],
    stats: {
        capital: "London",
        poplulation: "67.5 million",
        economicGrowthRate: "2.4%",
        currency: "British Pound (GBP)",
        language: "English",
        weather: [
            "London: 14°C - 23°C",
            "Manchester: 12°C - 21°C",
            "Birmingham: 13°C - 22°C",
            "Edinburgh: 11°C - 19°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, PTE)",
        "Personal Statement",
        "Academic References",
        "Valid passport copy",
        "Proof of finances (Bank statements, CAS)",
        "Tuberculosis (TB) test certificate",
        "ATAS certificate (for certain subjects)"
    ],
    intake: {
        title: "UK universities offer three main intakes:",
        intakes: [
            {
                name: "Autumn Intake",
                month: "Starts in September/October"
            },
            {
                name: "Spring Intake",
                month: "Starts in January/February"
            },
            {
                name: "Summer Intake",
                month: "Starts in May/June (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "Foundation Year",
            duration: "1 year"
        },
        {
            name: "HND/HNC",
            duration: "2 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "3-4 years"
        },
        {
            name: "Master's Degree",
            duration: "1-2 years"
        },
        {
            name: "PhD",
            duration: "3-4 years"
        }
    ],
    popularPrograms: {
        title: "The UK offers world-class education across all fields. Popular programs for international students include:",
        programs: [
            "Business Administration",
            "Engineering",
            "Medicine",
            "Law",
            "Computer Science",
            "Finance",
            "International Relations",
            "Creative Arts",
            "Social Sciences"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "GBP 8,000 - 15,000",
            bdt: "10,40,000 – 19,50,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "GBP 15,000 - 35,000",
            bdt: "19,50,000 – 45,50,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "GBP 18,000 - 40,000",
            bdt: "23,40,000 – 52,00,000 BDT"
        },
        {
            program: "PhD Programs",
            local: "GBP 20,000 - 45,000",
            bdt: "26,00,000 – 58,50,000 BDT"
        }
    ],
    topCities: {
        title: "The UK offers excellent education in several historic and vibrant cities. Key student cities include:",
        cities: [
            {
                name: "London",
                description: "Global capital with world-class universities and endless opportunities"
            },
            {
                name: "Manchester",
                description: "Vibrant city with excellent universities and strong industrial heritage"
            },
            {
                name: "Birmingham",
                description: "Major city with diverse universities and growing tech scene"
            },
            {
                name: "Edinburgh",
                description: "Historic capital with prestigious universities and cultural richness"
            },
            {
                name: "Glasgow",
                description: "Cultural city with excellent universities and friendly atmosphere"
            },
            {
                name: "Liverpool",
                description: "Historic port city with strong university presence and cultural scene"
            },
            {
                name: "Leeds",
                description: "Major city with excellent universities and growing business sector"
            },
            {
                name: "Bristol",
                description: "Creative city with strong university presence and innovation focus"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 20 hours per week during study periods and full-time during breaks. Students typically earn GBP 8-12 per hour. The work experience in UK's diverse economy can be highly valuable for career development.",
        postStudyWork: "The Graduate Route visa allows graduates to stay and work in the UK for up to 2 years (undergraduate/master's) or 3 years (PhD) after graduation. This provides excellent opportunities to gain work experience in the UK's strong economy and potentially qualify for skilled worker visas."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in UK?",
            answer: "To apply for a student visa, you need a Confirmation of Acceptance for Studies (CAS) from a UK institution, proof of English proficiency, financial capacity (GBP 1,334 per month for London, GBP 1,023 for other cities), TB test certificate, and a completed visa application form. The application is processed through UK Visas and Immigration."
        },
        {
            question: "What are the English language requirements for studying in UK?",
            answer: "Most UK institutions require IELTS (6.0-7.0), TOEFL (80-100), or PTE (50-70) scores. Some programs may require higher scores, especially for competitive programs and certain subjects like Medicine or Law."
        },
        {
            question: "Can I work while studying in UK?",
            answer: "Yes, international students can work up to 20 hours per week during study periods and full-time during breaks. The Graduate Route visa allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in UK?",
            answer: "Yes, there are various scholarships offered by the UK government, universities, and external organizations. These include Chevening Scholarships, Commonwealth Scholarships, university-specific scholarships, and subject-specific funding."
        },
        {
            question: "How much does it cost to study in UK from Bangladesh?",
            answer: "Studying in UK from Bangladesh costs around GBP 15,000-40,000 for tuition, GBP 1,000-1,500 per month for living expenses, and GBP 200-400 for health insurance annually. Total annual cost ranges from GBP 27,000-58,000."
        },
        {
            question: "What GPA is required to study in UK from Bangladesh?",
            answer: "To study in UK from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness. Some top universities may require higher GPAs."
        }
    ]
}
